import script from "./PLATFORM_LOAD_METRICS_EXCEEDED.vue?vue&type=script&setup=true&lang=ts"
export * from "./PLATFORM_LOAD_METRICS_EXCEEDED.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__